import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const VISIBLE = 4

export class Timeline {
  constructor () {
    this._roots = document.querySelectorAll('.s-timeline')

    if (!this._roots.length) {
      return
    }

    gsap.registerPlugin(ScrollTrigger)
    this._roots.forEach((root) => this.mount(root))
  }

  mount (root) {
    const track = root.querySelector('.s-timeline__track')
    const steps = [...root.querySelectorAll('.s-timeline__step')]

    if (!track || !steps.length) {
      return
    }

    const extra = Math.max(0, steps.length - VISIBLE)
    const mm = gsap.matchMedia()

    const distance = () => {
      const gap = parseFloat(getComputedStyle(track).gap) || 0

      return (steps[0].offsetWidth + gap) * extra
    }

    mm.add('(min-width: 1100px) and (prefers-reduced-motion: no-preference)', () => {
      root.classList.add('is-animated')

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top 80px',
          end: () => `+=${steps.length * 80}vh`,
          pin: true,
          scrub: 1.15,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      })

      steps.forEach((step, index) => {
        const reveal = step.querySelector('.s-timeline__reveal')
        const line = step.querySelector('.s-timeline__link-line')
        const dot = step.querySelector('.s-timeline__link-dot span')
        const at = index * 1.6

        if (line) {
          timeline.to(line, {
            opacity: 1,
            duration: 0.9,
            ease: 'none',
          }, at)
        }

        if (dot) {
          timeline.to(dot, {
            opacity: 1,
            duration: 0.7,
            ease: 'none',
          }, at + 0.45)
        }

        timeline.to(reveal, {
          opacity: 1,
          duration: 1.1,
          ease: 'none',
        }, line ? at + 0.25 : at)
      })

      if (extra > 0) {
        timeline.to(track, {
          x: () => -distance(),
          duration: extra * 1.6,
          ease: 'none',
        }, VISIBLE * 1.6)
      }

      return () => {
        root.classList.remove('is-animated')
        gsap.set(track, { x: 0 })
        gsap.set(root.querySelectorAll('.s-timeline__reveal, .s-timeline__link-line, .s-timeline__link-dot span'), { clearProps: 'opacity' })
      }
    })
  }
}
